/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Direction of transportation.
 * `O` - Outward
 * `R` - Return
 * `RT` - Roundtrip
 * `OJ` - Open Jaw
 * 
 * @export
 */
export const Direction = {
    O: 'O',
    R: 'R',
    RT: 'RT',
    OJ: 'OJ'
} as const;
export type Direction = typeof Direction[keyof typeof Direction];


export function instanceOfDirection(value: any): boolean {
    for (const key in Direction) {
        if (Object.prototype.hasOwnProperty.call(Direction, key)) {
            if (Direction[key as keyof typeof Direction] === value) {
                return true;
            }
        }
    }
    return false;
}

export function DirectionFromJSON(json: any): Direction {
    return DirectionFromJSONTyped(json, false);
}

export function DirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Direction {
    return json as Direction;
}

export function DirectionToJSON(value?: Direction | null): any {
    return value as any;
}

export function DirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): Direction {
    return value as Direction;
}

